import React, {FC, useState} from 'react'
import CommerciumLoaderHost from 'src/utils/CommerciumLoaderHost'
import {DashboardPeriodFilter, DashboardPeriodOption} from '../utils/dashboardPeriodUtils'
import {useTopStockedItems} from '../hooks/useTopStockedItems'

type Props = {
  filterOptions: DashboardPeriodOption[]
}

const TopStockedItemsCard: FC<Props> = ({filterOptions}) => {
  const [period, setPeriod] = useState<DashboardPeriodFilter>('this_month')
  const {rows, loading} = useTopStockedItems(period)

  return (
    <div className='dashboard-panel-card dashboard-widget-card mb-0'>
      <div className='dashboard-panel-header'>
        <h3>Top Stocked Items</h3>
        {/*
        <select
          className='dashboard-filter-select dashboard-period-select'
          value={period}
          onChange={(e) => setPeriod(e.target.value as DashboardPeriodFilter)}
        >
          {filterOptions.map((option) => (
            <option key={option.key} value={option.key}>
              {option.label}
            </option>
          ))}
        </select>
        */}
      </div>
      <div className='dashboard-panel-body'>
        {loading ? (
          <CommerciumLoaderHost variant='section' layout='centered' />
        ) : rows.length > 0 ? (
          <table className='dashboard-data-table'>
            <thead>
              <tr>
                <th>Item Details</th>
                <th className='text-end'>Available Qty</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>
                    {row.name}
                    <span className='dashboard-sku-text'>SKU: {row.sku}</span>
                  </td>
                  <td className='text-end fw-semibold'>{row.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='dashboard-empty fs-7'>
            No stocked item data available for this period.
          </div>
        )}
      </div>
    </div>
  )
}

export default TopStockedItemsCard
